import * as types from "../constants/actionConstants";

const initialState = {
    flag: false
};

function questionnaireVersionsModeFlagReducer(state = initialState, action) {
    switch (action.type) {
        case types.QUESTIONNAIRE_VERSIONS_MODE_FLAG:
            return {flag: action.flag};
        default:
            return state;
    }
}

export default questionnaireVersionsModeFlagReducer;